import ROLES from '../../constants/roles';

export function isAdmin(authUser) {
  return !!authUser && !!authUser.roles && !!authUser.roles[ROLES.ADMIN];
}

export function isSignedInUser(authUser) {
  return !!authUser;
}
